/* eslint-disable max-len */
import React from 'react'
import {
  ContentSection,
  DescriptionList,
  Layout,
  Paragraph,
  Heading,
} from '@vwfs-bronson/bronson-react'
import { useTranslation } from 'react-i18next'
import './style.css'
import {
  addThousandSeparator,
  date,
  formatPrice,
} from '../../../services/common/format'
import { FirstUsage } from '../../../models/enums'
import { useSelector } from 'react-redux'
import {
  getOriginSystem,
  isAUDI,
  isVtiGiS,
} from '../../../services/common/utils'
import SummaryVehicleSectionSuffix from './SummaryVehicleSectionSuffix'
import { InfoTooltip } from '../../../components/InfoTooltip'
import { getStorefrontData } from '../../../services/redux/features/storefront.redux'

const SummaryVehicleSection = ({
  vehicleData,
}) => {
  const { t } = useTranslation()
  const storefrontData = useSelector(getStorefrontData)

  const vehicleDataFormated = [
    vehicleData?.model?.manufacturer,
    vehicleData?.model?.description,
    // eslint-disable-next-line no-negated-condition
    ...(!isAUDI(storefrontData) ? [vehicleData?.vin] : []),
    vehicleData?.initialRegistrationDate ? date(vehicleData?.initialRegistrationDate) : '',
    formatPrice(vehicleData?.purchasePriceAmount),
    ...(isVtiGiS(storefrontData) ? ['Mietwagen'] : []),
    vehicleData?.odometer ? t(`summaryVehicle:odometerValue`, { odometer: addThousandSeparator(vehicleData?.odometer) }) : '',
  ]
  const descriptionList = t(
    `summaryVehicle:${getOriginSystem(storefrontData)}:descriptionList`,
    {
      returnObjects: true,
      defaultValue: t(`summaryVehicle:default:descriptionList`, {
        returnObjects: true,
      }),
    }
  ) as any
  return (
    <>
      {' '}
      <ContentSection.ComponentWrapper className="u-mb-none">
        <Heading level={2} className="u-text-left">{t('summaryVehicle:title')}</Heading>
        <Layout>
          {descriptionList?.items?.length > 0 && (
            <Layout.Item>
              <Layout>
                <Layout.Item default="1/1">
                  <DescriptionList grid className="summaryVehicle">
                    {descriptionList &&
                      descriptionList?.items?.map(
                        (item: string, index: number) => {
                          if ((isVtiGiS(storefrontData) && item === 'Vorverwendung' && storefrontData?.vehicleData?.firstUsage !== FirstUsage.RENTAL_CAR) || !vehicleDataFormated?.[index]) {
                            // in that case we have to not show this Vorverwendung field
                            return <></>;
                          }
                          return (
                          <DescriptionList.Group
                            key={item}
                            termText={
                              <span>
                                {item}
                                {descriptionList?.tooltip?.[item] && (
                                  <InfoTooltip label={item} text={descriptionList?.tooltip?.[item]} />
                                )}
                              </span>
                            }
                          >
                            <DescriptionList.Detail>
                              <Paragraph>
                                {vehicleDataFormated?.[index]}
                              </Paragraph>
                            </DescriptionList.Detail>
                          </DescriptionList.Group>
                        )}
                      )}
                  </DescriptionList>
                  {/* Summary Vehicle Section Suffix component */}
                  <SummaryVehicleSectionSuffix />
                </Layout.Item>
              </Layout>
            </Layout.Item>
          )}
        </Layout>
      </ContentSection.ComponentWrapper>
    </>
  )
}

export default SummaryVehicleSection
